import { render, staticRenderFns } from "./foreUPGroups.vue?vue&type=template&id=a885e032&scoped=true"
import script from "./foreUPGroups.vue?vue&type=script&lang=js"
export * from "./foreUPGroups.vue?vue&type=script&lang=js"
import style0 from "./foreUPGroups.vue?vue&type=style&index=0&id=a885e032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a885e032",
  null
  
)

export default component.exports